import { render, staticRenderFns } from "./BalanceVsCashflowButton.vue?vue&type=template&id=2bf46503&scoped=true&"
import script from "./BalanceVsCashflowButton.vue?vue&type=script&lang=js&"
export * from "./BalanceVsCashflowButton.vue?vue&type=script&lang=js&"
import style0 from "./BalanceVsCashflowButton.vue?vue&type=style&index=0&id=2bf46503&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf46503",
  null
  
)

export default component.exports